import { render, staticRenderFns } from "./PortaisCassems.vue?vue&type=template&id=55a1008e"
import script from "./PortaisCassems.vue?vue&type=script&lang=js"
export * from "./PortaisCassems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports